import { ObligationRulesFrequency } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

interface CreateComplianceItemRequest {
  corporationId: number;
  complianceType?: string;
  dueDate?: string;
  effectiveEndDate?: string;
  effectiveStartDate?: string;
  caFirmId?: string;
  fiscalYear?: number;
  isCustom?: boolean;
  customFields?: {
    explicitTitle: string;
    customFrequency?: ObligationRulesFrequency;
    customCategory?: string;
  };
}

export async function createComplianceItem(data: CreateComplianceItemRequest) {
  const res = await fetcher('compliance', {
    method: 'POST',
    body: data,
  });

  return res;
}
